<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onClickSave)" autocomplete="off">
            <div slot="no-body" class="full-page-bg-color">
              <div class="vx-row">
                <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                  <img src="@/assets/images/logo/its_logo_horizontal.png" alt="Nimble Logo" class="mx-auto" width="250">
                </div>
                <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg"
                  v-if="is_verified">
                  <div class="p-8">
                    <div class="vx-card__title mb-8">
                      <h4 class="mb-4">Setup Your Account</h4>
                      <p>Please setup your new password.</p>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-full">
                        <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                          <vs-input name="password" type="email" v-model="form.email" disabled class="w-full"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-full">
                        <ValidationProvider vid="password" name="password"
                          rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8"
                          v-slot="{ errors }">
                          <div class="relative">
                            <vs-input name="password" :type="showPassword ? 'text' : 'password'"
                              label-placeholder="Password" v-model="form.password" class="w-full"
                              :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                              val-icon-pack="feather" />
                            <div @click.stop="showPassword = !showPassword"
                              class="flex items-center text-gray-500 focus:outline-none show-button">
                              <span v-if="showPassword">
                                <img class="float-right" :class="{ 'mb-6 mr-4': !!errors[0] }"
                                  src="@/assets/images/pages/login/hidden.png" width="16px" height="16px" />
                              </span>
                              <span v-else>
                                <img class="float-right" :class="{ 'mb-6 mr-4': !!errors[0] }"
                                  src="@/assets/images/pages/login/show.png" width="16px" height="16px" />
                              </span>
                            </div>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-3">
                      <div class="vx-col w-full">
                        <ValidationProvider vid="password_confirmation" name="password_confirmation"
                          rules="required|no_whitespace|one_uppercase|one_lowercase|one_number|one_special|min:8"
                          v-slot="{ errors }">
                          <div class="relative">
                            <vs-input name="password_confirmation"
                              :type="showPasswordConfirmation ? 'text' : 'password'"
                              label-placeholder="Confirm Password" v-model="form.password_confirmation"
                              class="w-full mb-8" :danger="!!errors[0]" :danger-text="errors[0]"
                              val-icon-danger="icon-x" val-icon-pack="feather" />
                            <div @click.stop="showPasswordConfirmation = !showPasswordConfirmation"
                              class="flex items-center text-gray-500 focus:outline-none show-button">
                              <span v-if="showPasswordConfirmation">
                                <img class="float-right" :class="{ 'mb-6 mr-4': !!errors[0] }"
                                  src="@/assets/images/pages/login/hidden.png" width="16px" height="16px" />
                              </span>
                              <span v-else>
                                <img class="float-right" :class="{ 'mb-6 mr-4': !!errors[0] }"
                                  src="@/assets/images/pages/login/show.png" width="16px" height="16px" />
                              </span>
                            </div>
                          </div>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                      <vs-button type="border" to="/pages/login"
                        class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go
                        Back To Login
                      </vs-button>
                      <vs-button id="submit-button" button="submit" class="w-full sm:w-auto">Save Changes</vs-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const StaffRepository = RepositoryFactory.get('staff');
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      is_verified: false,
      showPassword: false,
      showPasswordConfirmation: false,
      form: {
        email: '',
        code: this.$route.params.code,
        password: '',
        password_confirmation: ''
      },
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  async mounted() {
    await this.checkVerification();
  },
  components: {
    'countdown': VueCountdown
  },
  methods: {
    ...mapActions(['login']),
    async checkVerification() {
      this.isLoading = true
      try {
        const { data } = (await StaffRepository.accountVerify(this.form.code)).data
        this.form.email = data.email
        this.is_verified = data.is_email_verified
        if (data.is_password_set && data.is_email_verified) {
          this.$router.push('/pages/login')
        } else {
          this.showSuccessMessage('Your account verified. Please set your password!')
        }
      } catch (e) {
        this.convertAndNotifyError(e)
        this.$router.push('/pages/login')
      }
    },
    async onClickSave() {
      await this.$vs.loading({
        container: '#submit-button',
        scale: 0.45
      })
      try {
        await StaffRepository.storeStaffPassword(this.form)
        await this.login({
          email: this.form.email,
          password: this.form.password,
        })
        this.$router.push('/')
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        this.$vs.loading.close('#submit-button > .con-vs-loading')
      }
    }
  }
}

</script>
<style scoped>
.show-button {
  background: none;
  border: none;
  cursor: pointer;
  align-content: right;
  padding: 0;
  background: none;
  border: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
}
</style>